import { Col, Row } from 'react-bootstrap';

const YourAssumptions = (
  {
    iROR,
    iEECont,
    iRetAge,
    iIncRep,
  }: { iROR: number, iEECont: number, iRetAge: number, iIncRep: number }) => (
  <div className="px-8">
    <Row className="fw-light text-fs-6 text-dark-gray pt-13 lh-xs border-bottom pt-3 pb-3 ">
      <Col>Retirement Age</Col>
      <Col className="text-end">{iRetAge}</Col>
    </Row>
    <Row className="fw-light text-fs-6 text-dark-gray lh-xs border-bottom pt-5 pb-5">
      <Col>Annual Contributions</Col>
      <Col className="text-end">{`${iEECont}%`}</Col>
    </Row>
    <Row className="fw-light text-fs-6 text-dark-gray lh-xs border-bottom pt-5 pb-5 ">
      <Col>Project Investment Earnings</Col>
      <Col className="text-end">{`${iROR}%`}</Col>
    </Row>
    <Row className="fw-light text-fs-6 text-dark-gray lh-xs border-bottom pt-5 pb-5 ">
      <Col>Replacement Ratio</Col>
      <Col className="text-end">{`${iIncRep}%`}</Col>
    </Row>
    <Row className="fw-light text-fs-6 text-dark-gray lh-xs border-bottom pt-5 pb-5 ">
      <Col>Consumer Price Index Increase</Col>
      <Col className="text-end">3.0%</Col>
    </Row>
    <Row className="fw-light text-fs-6 text-dark-gray lh-xs pt-5 pb-5 ">
      <Col>National Average Wage Increase</Col>
      <Col className="text-end">3.0%</Col>
    </Row>
  </div>
);

export default YourAssumptions;
